import React from 'react';
import { Box, Typography, Container, List, ListItem, ListItemIcon, ListItemText, Divider } from '@mui/material';

const sections = [
  {
    title: 'About Film-hook Apps',
    paragraphs: [
      'Welcome to the official Filmhook Apps marketing page.',
      'Filmhook Apps is a professional networking, recruitment, collaboration, and marketplace platform designed for the global media and entertainment industry. Our mission is to connect creators, artists, technicians, businesses, recruiters, production houses, agencies, and organizations through a secure and professional digital ecosystem.',
      'Whether you are an actor, director, producer, musician, photographer, journalist, designer, business owner, freelancer, or creative professional, Filmhook Apps helps you discover opportunities, build professional connections, showcase your work, and grow your career.',
      'Filmhook Apps is developed and operated by FILM-HOOK MEDIAAPPS PRIVATE LIMITED. The platform is designed to support professionals across multiple creative industries by providing tools for networking, collaboration, recruitment, portfolio management, business promotion, marketplace listings, and industry communication.',
      'Our objective is to simplify professional collaboration while helping creators and businesses connect through one trusted platform.'
    ]
  },
  {
    title: 'Our Mission',
    paragraphs: [
      'Our mission is to build one of the world\'s leading professional platforms for the creative and entertainment industries by enabling meaningful connections, business growth, and career opportunities in a secure, transparent, and professional environment.'
    ]
  },
  {
    title: 'What You Can Do with Filmhook Apps',
    paragraphs: [
      'Filmhook Apps provides features that help professionals and businesses collaborate more efficiently. You can:'
    ],
    bullets: [
      'Showcase your professional portfolio and creative reels.',
      'Connect and network with actors, directors, producers, and crew members globally.',
      'Post and apply for industry casting calls, auditions, and job opportunities.',
      'Promote your business page, rental location, or equipment services.',
      'Buy, sell, or rent production assets in our integrated marketplace.',
      'Communicate securely via voice, video calls, and group chats.'
    ]
  }
];

const MarketingPage = () => {
  return (
    <Box sx={{ py: { xs: 4, sm: 8, md: 12 }, minHeight: '80vh' }}>
      <Container maxWidth="md">
        <Box
          sx={{
            background: 'var(--bg-card)',
            backdropFilter: 'blur(20px)',
            WebkitBackdropFilter: 'blur(20px)',
            border: '1px solid var(--border-color)',
            borderRadius: '24px',
            p: { xs: 2.5, sm: 4, md: 7 },
            boxShadow: '0 16px 48px rgba(0,0,0,0.2)',
          }}
        >
          <Typography variant="h3" fontWeight={800} gutterBottom sx={{ color: 'var(--text-heading)', textAlign: 'center', mb: 1, fontSize: { xs: '1.8rem', sm: '2.5rem', md: '3rem' } }}>
            Marketing Page
          </Typography>
          <Typography variant="h6" sx={{ color: '#5dade2', textAlign: 'center', mb: 1, fontWeight: 500, letterSpacing: '0.5px', fontSize: { xs: '0.9rem', sm: '1.1rem', md: '1.25rem' } }}>
            FILM-HOOK MEDIAAPPS PRIVATE LIMITED
          </Typography>
          <Typography variant="subtitle2" sx={{ color: 'var(--text-muted)', mb: 3, fontSize: { xs: '0.75rem', sm: '0.875rem' } }} textAlign="center">
            Last Updated: July 2026
          </Typography>
          <Box sx={{ width: 80, height: 3, background: 'linear-gradient(90deg, #07a4f5, #5dade2)', mx: 'auto', mb: 6, borderRadius: '2px' }} />

          {sections.map((section, idx) => (
            <Box key={idx} sx={{ mb: 6 }}>
              <Typography variant="h5" fontWeight={700} gutterBottom sx={{ color: 'var(--text-heading)', mb: 2, fontSize: { xs: '1.2rem', sm: '1.35rem', md: '1.5rem' } }}>
                {section.title}
              </Typography>
              
              {section.paragraphs.map((p, pIdx) => (
                <Typography key={pIdx} variant="body1" sx={{ color: 'var(--text-secondary)', lineHeight: 1.8, mb: 2, textAlign: 'justify', fontSize: { xs: '0.88rem', md: '1rem' } }}>
                  {p}
                </Typography>
              ))}

              {section.bullets && (
                <List sx={{ pl: 2, mb: 2 }}>
                  {section.bullets.map((bullet, bIdx) => (
                    <ListItem key={bIdx} alignItems="flex-start" disableGutters sx={{ py: 0.5 }}>
                      <ListItemIcon sx={{ minWidth: '32px', mt: '8px' }}>
                        <Box sx={{ width: 6, height: 6, borderRadius: '50%', bgcolor: '#5dade2' }} />
                      </ListItemIcon>
                      <ListItemText
                        primary={
                          <Typography variant="body1" sx={{ color: 'var(--text-secondary)', lineHeight: 1.7, textAlign: 'justify', fontSize: { xs: '0.88rem', md: '1rem' } }}>
                            {bullet}
                          </Typography>
                        }
                      />
                    </ListItem>
                  ))}
                </List>
              )}

              {idx < sections.length - 1 && (
                <Divider sx={{ mt: 5, borderColor: 'var(--border-subtle)' }} />
              )}
            </Box>
          ))}
        </Box>
      </Container>
    </Box>
  );
};

export default MarketingPage;
